import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import { Button, Dialog, Grid } from "@mui/material";
import Signifier from "../../App/Components/Signifier/Signifier";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../App/State/Slices/SelectedCareersClientSlice";
import Breadcrumb from "../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import EventTypeTableCell from "./Components/EventTypeTableCell";
import SortableTable from "../../App/Components/Table/SortableTable";
import { getEventTypes } from "./EventTypesService";
import AddEventTypeModal from "./Components/AddEventTypeModal";

function EventTypesPage() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    autocomplete: {
      width: "35%",
      paddingBottom: "20px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    hint: {
      position: "absolute",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: "auto",
      marginRight: "auto",
      width: "300px",
      height: "300px",
      fontSize: "32px",
      textAlign: "center",
      color: "rgba(0,0,0,.6)",
    },
  }));

  const classes = useStyles();

  const selectCareersClient = useSelector(selectCareersClientValue);
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const columns = [
    { label: "Name", propName: "name" },
    { label: "Edit", propName: "" },
    { label: "Delete", propName: "" },
  ];

  useEffect(() => {
    if (selectCareersClient !== null) {
      setLoading(true);
      getEventTypes(selectCareersClient.id).then((response) => {
        setTableData(response);
        setLoading(false);
      });
    }
  }, [selectCareersClient]);

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Event Types
        </h1>
        <div className={classes.root}>
          {selectCareersClient === null ? (
            <div className={classes.hint}>
              <span>Select a client</span>
            </div>
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Button
                  style={{ marginTop: "20px", marginBottom: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={() => setOpenAddModal(!openAddModal)}
                >
                  Add Event Type
                </Button>
              </Grid>
              <SortableTable
                columns={columns}
                tableData={tableData}
                rowComponent={EventTypeTableCell}
                loading={loading}
                setTableData={setTableData}
                defaultSortIndex={0}
              />
            </Grid>
          )}
        </div>
      </div>
      <Dialog open={openAddModal} onClose={() => setOpenAddModal(false)}>
        <AddEventTypeModal
          openModal={setOpenAddModal}
          client={selectCareersClient}
          setShowSignifier={setShowSignifier}
          setResponseMessage={setResponseMessage}
          setShowError={setShowError}
          setTableData={setTableData}
        />
      </Dialog>
    </>
  );
}

export default EventTypesPage;
